"use client"

import { useEffect, useState } from "react"
import { createClient } from "@/utils/supabase/client"
import { OfferCheckoutSheet } from "./offer-checkout-sheet"

export function GlobalOfferCheckout() {
  const [userId, setUserId] = useState<string | null>(null)
  const [offerId, setOfferId] = useState<string | null>(null)

  useEffect(() => {
    const supabase = createClient()
    supabase.auth.getUser().then(({ data }) => setUserId(data.user?.id ?? null))
    const { data: sub } = supabase.auth.onAuthStateChange((_event, session) => {
      setUserId(session?.user?.id ?? null)
    })
    return () => sub.subscription.unsubscribe()
  }, [])

  useEffect(() => {
    const handler = (e: Event) => {
      const detail = (e as CustomEvent).detail as { offerId?: string } | undefined
      if (detail?.offerId) setOfferId(detail.offerId)
    }
    window.addEventListener("open-offer-checkout", handler as EventListener)
    return () => window.removeEventListener("open-offer-checkout", handler as EventListener)
  }, [])

  return (
    <OfferCheckoutSheet
      open={offerId != null}
      onOpenChange={(o) => {
        if (!o) setOfferId(null)
      }}
      offerId={offerId}
      userId={userId}
    />
  )
}
